import React, { useState, useEffect } from "react";
import { API_ENDPOINTS } from "../config/api";
import "../css/ProtectedRoute.css";
import aroma from "../img/ratatui.gif";

const ProtectedRoute = ({ element }) => {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [verifying, setVerifying] = useState(false);

  useEffect(() => {
    const isAuthenticatedInLocalStorage = localStorage.getItem("isAuthenticated");
    if (isAuthenticatedInLocalStorage === "true") {
      setIsAuthenticated(true);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setVerifying(true);
    try {
      const res = await fetch(API_ENDPOINTS.admin.verify, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ login: login.trim(), password: password.trim() }),
      });
      const data = await res.json();
      if (data.success) {
        setIsAuthenticated(true);
        localStorage.setItem("isAuthenticated", "true");
        sessionStorage.setItem(
          "adminAuth",
          JSON.stringify({ login: login.trim(), password: password.trim() })
        );
      } else {
        alert("Неверный логин или пароль");
      }
    } catch (error) {
      console.error("Auth error:", error);
      alert("Ошибка подключения. Попробуйте позже.");
    } finally {
      setVerifying(false);
    }
  };

  if (isAuthenticated) {
    return <div>{React.cloneElement(element)}</div>;
  }

  return (
      <div className="password-container">
        <h1>CRM Fast Delivery</h1>
        <img src={aroma} alt="Loading..." className="gif" />
        <form onSubmit={handleSubmit} className="login-form">
          <h2>Введите логин и пароль</h2>
          <input type="text" value={login} onChange={(e) => setLogin(e.target.value)} placeholder="Введите логин" required />
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Введите пароль" required />
          <button type="submit" disabled={verifying}>{verifying ? "..." : "Войти"}</button>
        </form>
      </div>
  );
};

export default ProtectedRoute;
